/**
 * Wipes a lingering text selection so it cannot hijack the drag that is about
 * to start. A no-op when the selection is collapsed (a plain cursor in a text
 * field), so this never disturbs normal typing.
 *
 * Called from `onMouseDown`, not `dragstart`: the HTML5 Drag & Drop API picks
 * between a text-selection drag and an element drag at the moment the browser
 * notices an existing, non-collapsed selection under the pointer — that
 * choice is made before `dragstart` fires, so clearing the selection there is
 * too late. Mousedown fires ahead of the browser's own drag-threshold check,
 * so a selection cleared here can never be picked up.
 */
export const clearSelectionBeforeDrag = () => {
  const selection = window.getSelection();
  if (!selection || selection.isCollapsed) return;
  selection.removeAllRanges();
};
